<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-user-academies">

        <page-title :title="'Twoje Akademie Piwne'" :back="true"></page-title>

        <slide-y-up-transition :duration="400" :delay="200">
            <p v-if="show && academies.length === 0" class="text-center">Nie masz jeszcze żadnych rejestracji.</p>
        </slide-y-up-transition>

        <div v-for="(item,index) in academies" :key="item.slug">
            <item-user-academy
                    :index="index+1"
                    :hash="item.hash"
                    :academy_name="item.academy_name"
                    :city="item.city"
                    :date_meeting="item.date_meeting"
                    :status="item.status">
            </item-user-academy>
        </div>

    </div>
</template>

<script>
    import api from '@/services/Api';
    import PageTitle from '@/components/PageTitle.vue';
    import ItemUserAcademy from '@/items/ItemUserAcademy';

    export default {
        name: 'UserAcademies',
        components: { PageTitle, ItemUserAcademy },
        data(){
            return {
                show: false,
                academies: [],
            }
        },
        mounted(){
            this.show = true;
            this.getAcademies();
        },
        methods: {
            // todo refactor to vuex
            getAcademies(){
                api({url: '/users/academies?per_page=100', method: 'GET'})
                    .then(resp => {
                        this.academies = resp.data.data
                    })
            }
        }
    }
</script>